<template>
  <Grid gtc="200px 1fr" class="decision overflow-hidden">
    <template v-if="quickViewItems">
      <ModalSidebar ref="modalSidebar" :items="quickViewItems" @item-selected="openQuickView" />

      <Grid v-if="quickView" gtr="auto 1fr auto" class="overflow-hidden">
        <QuickViewHeader :quick-view="quickView" />

        <ModalBody>
          <Grid v-if="quickView" :key="quickView.id" gtc="repeat(3, 1fr)" gap="var(--r-space-sp)" align-items="start">
            <Widgets :id="quickView.id" style="grid-column: span 3" />
            <TermsCard :data="sortedTerms" style="grid-column: span 2" />
            <NotesCard
              :entity="{ name: 'subscription', id: quickView.subscription.id }"
              store-namespace="subscriptions"
            />
          </Grid>
        </ModalBody>

        <ModalFooter>
          <RBtn size="big" type="primary" @click="acceptOrCancel('ACCEPT')">Accept</RBtn>
          <RBtn size="big" type="tertiary" @click="acceptOrCancel('CANCEL')">Cancel subscription</RBtn>
        </ModalFooter>
      </Grid>
    </template>
  </Grid>
</template>

<script>
import * as apiTo from '@/modular-api'
import { checkQuickView, getCount, getTaskData, openQuickView, setSubtitle } from '../modals-shared'
// Libraries
import { cloneDeep } from 'lodash'
// Components
import TermsCard from '@/reusable/license/tab-terms/TabTerms'
import NotesCard from '@components/lm-blocks/Notes'
import ModalSidebar from '../components/ModalSidebar'
import ModalBody from '../components/ModalBody'
import ModalFooter from '../components/ModalFooter'
import Widgets from './Widgets/Widgets'
import QuickViewHeader from './QuickViewHeader'

export default {
  components: {
    TermsCard,
    NotesCard,
    ModalSidebar,
    ModalBody,
    ModalFooter,
    Widgets,
    QuickViewHeader
  },

  props: {
    periodId: [Number, String]
  },

  data() {
    return {
      quickViewItems: null,
      quickView: null
    }
  },

  computed: {
    sortedTerms() {
      if (!this.quickView.license_period || !this.quickView.license_period.terms) return []
      let terms = cloneDeep(this.quickView.license_period.terms)
      return terms.sort((a, b) => Number(b.active) - Number(a.active))
    }
  },

  watch: {
    quickViewItems: 'setSubtitle'
  },

  created() {
    this.getTaskData('decisions').then(({ data }) => (this.quickViewItems = data.result))
  },

  methods: {
    getCount,
    getTaskData,
    checkQuickView,
    setSubtitle: setSubtitle('Subscriptions'),
    openQuickView: openQuickView('decisions'),

    acceptOrCancel(acceptOrCancel) {
      this.$emit('set-loader', true)

      apiTo[`${acceptOrCancel}_SUBSCRIPTION_PERIOD`](this.quickView.id)
        .then(() => {
          this.updateRenewalStatus()
          this.checkQuickView()
        })
        .finally(() => this.$emit('set-loader', false))
    },

    updateRenewalStatus() {
      // renewal status chart in dashboard
      if (this.$store.getters['widgets/renewalStatusChartData']) {
        // if renewal-status is available
        this.$store.dispatch('widgets/getChartData', {
          chartName: 'renewal-status',
          context: 'dashboard',
          subcontext: 'graphs'
        })
      }
    }
  }
}
</script>
